// src/components/Navbar.tsx
import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import { Menu, X } from "lucide-react";
import { NavLink } from "react-router-dom";
import SocialLinks from "./SocialLinks";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={cn(
        "fixed top-0 left-0 right-0 z-50 py-4 transition-all duration-300",
        isScrolled ? "glass shadow-sm py-3" : "bg-transparent"
      )}
    >
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between">
        <NavLink
          to="/"
          end
          className="text-foreground font-display text-2xl font-medium"
          onClick={() => setIsOpen(false)}
        >
          Priya Pareek
        </NavLink>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              cn(
                "transition-colors duration-300",
                isActive
                  ? "text-primary underline"
                  : "text-muted-foreground hover:text-primary hover:underline"
              )
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            end
            className={({ isActive }) =>
              cn(
                "transition-colors duration-300",
                isActive
                  ? "text-primary underline"
                  : "text-muted-foreground hover:text-primary hover:underline"
              )
            }
          >
            About
          </NavLink>
          <NavLink
            to="/work"
            end
            className={({ isActive }) =>
              cn(
                "transition-colors duration-300",
                isActive
                  ? "text-primary underline"
                  : "text-muted-foreground hover:text-primary hover:underline"
              )
            }
          >
            Work
          </NavLink>
          <NavLink
            to="/contact"
            end
            className={({ isActive }) =>
              cn(
                "transition-colors duration-300",
                isActive
                  ? "text-primary underline"
                  : "text-muted-foreground hover:text-primary hover:underline"
              )
            }
          >
            Contact
          </NavLink>
          <SocialLinks />
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 hover:bg-transparent border-none focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? "Close menu" : "Open menu"}
        >
          {isOpen ? <X className="h-6 w-6 text-foreground" /> : <Menu className="h-6 w-6 text-foreground" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={cn(
          "fixed top-0 left-0 bg-background/80 backdrop-blur-lg transition-transform duration-300 ease-in-out z-50 md:hidden w-full",
          isOpen ? "translate-x-0" : "translate-x-full"
        )}
      >
        <button
          className="absolute top-6 right-6 p-2 border border-black rounded-sm hover:bg-gray-100/50 transition-colors duration-200 focus:outline-none"
          onClick={() => setIsOpen(false)}
          aria-label="Close menu"
        >
          <X className="h-6 w-6 text-foreground" />
        </button>
        <div className="container mx-auto px-4 py-6 flex flex-col items-center space-y-6 pt-16 pb-6">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              cn(
                "text-lg font-medium transition-colors duration-300",
                isActive
                  ? "text-primary underline"
                  : "text-foreground hover:text-primary hover:underline"
              )
            }
            onClick={() => setIsOpen(false)}
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            end
            className={({ isActive }) =>
              cn(
                "text-lg font-medium transition-colors duration-300",
                isActive
                  ? "text-primary underline"
                  : "text-foreground hover:text-primary hover:underline"
              )
            }
            onClick={() => setIsOpen(false)}
          >
            About
          </NavLink>
          <NavLink
            to="/work"
            end
            className={({ isActive }) =>
              cn(
                "text-lg font-medium transition-colors duration-300",
                isActive
                  ? "text-primary underline"
                  : "text-foreground hover:text-primary hover:underline"
              )
            }
            onClick={() => setIsOpen(false)}
          >
            Work
          </NavLink>
          <NavLink
            to="/contact"
            end
            className={({ isActive }) =>
              cn(
                "text-lg font-medium transition-colors duration-300",
                isActive
                  ? "text-primary underline"
                  : "text-foreground hover:text-primary hover:underline"
              )
            }
            onClick={() => setIsOpen(false)}
          >
            Contact
          </NavLink>
          <SocialLinks className="pt-4" />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;